module.exports = __webpack_public_path__ + "static/media/home.7d63716b.svg";